<template lang="pug">
.winning-dialog-container(
  v-if="show"
  @touchmove.prevent
)
  .shadow(@click="close")
  .dialog-content
    .header 下次如何找到 哈啰超级会员
    .tips
      .color APP内-
      .my-page 我的页面
      .top 顶部
      .supermember 「超级会员」
    .tips-bg
    .btn(@click="close") 知道了
</template>
<script>
export default {
  components: {
  },
  props: {
    show: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
    };
  },
  watch: {
  },
  created() {

  },
  mounted() {
  },
  destroyed() {
  },
  methods: {
    close() {
      this.$emit('close');
      this.$emit('update:show', false);
    },
  },
};
</script>

<style lang="less" scoped>
.winning-dialog-container {
  width: 100%;
  height: 100vh;
  position: fixed;
  left: 0;
  top: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 999;

  .shadow {
    width: 100%;
    height: 100%;
    background-color: #000;
    opacity: 0.7;
    position: absolute;
    left: 0;
    top: 0;
  }

  .dialog-content {
    position: relative;
    width: 3.21rem;
    height: 3.08rem;
    background-image: url(https://m.hellobike.com/resource/gallery/350/-2Pgikfd_tipBg.png);
    background-size: 100%;
    background-repeat: no-repeat;
    z-index: 1;

    .header {
      width: 2.42rem;
      height: 0.28rem;
      display: flex;
      justify-content: center;
      align-items: center;
      margin: 0.16rem auto 0;
      font-size: 0.18rem;
      font-weight: 500;
    }

    .tips {
      margin: 0.04rem auto 0;
      display: flex;
      justify-content: center;
      align-items: center;
      width: 2.42rem;
      height: 0.18rem;

      .color {
        color: #879099;
        font-size: 0.14rem;
      }

      .my-page {
        color: #242729;
        font-size: 0.14rem;
      }

      .top {
        color: #879099;
        font-size: 0.14rem;
        margin-left: 0.04rem;
      }

      .supermember {
        color: #ff5c0a;
        font-size: 0.14rem;
      }
    }

    .tips-bg {
      width: 2.72rem;
      height: 1.46rem;
      background-image: url(https://m.hellobike.com/resource/gallery/350/gcivrSD8_Frame2.png);
      background-size: 100%;
      background-repeat: no-repeat;
      margin: 0.15rem auto 0;
    }

    .btn {
      width: 2.42rem;
      height: 0.42rem;
      background-color: #ff5c0a;
      border-radius: 0.12rem;
      font-weight: 500;
      font-size: 0.16rem;
      display: flex;
      justify-content: center;
      align-items: center;
      color: #fff;
      margin: 0.13rem auto 0;
    }
  }
}
</style>
